const ToggleDetailButton = ({ onToggleDetails, showDetail }) => {
  return (
    <button
      type="button"
      onClick={onToggleDetails}
      className="toggle-detail-bar"
      title={showDetail ? "Replier le détail" : "Déplier le détail"}
    >
      <i className={"fa fa-angle-" + (showDetail ? "up" : "down")}></i>
    </button>
  );
};

export default ToggleDetailButton;
